<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <v-card
          class="mx-auto"
          max-width="400"
          :loading="loading"
        >
          <v-card-title class="text-h6 font-weight-bold">
            $ {{ (parseFloat(edited.deuda_usuario) || 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon color="primary">mdi-cash-multiple</v-icon>
          </v-card-title>

          <v-card-subtitle class="pb-1 font-weight-medium">Deuda usuario total.</v-card-subtitle>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-card-text class="pt-0 px-4 pb-3">
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="green darken-1">mdi-calendar-range</v-icon>
                Últimos 30 días
              </span>
              <span class="text-subtitle-2 font-weight-bold green--text text--darken-2">
                $ {{ (parseFloat(edited.deuda_usuario_30) || 0) | formatToTwoDecimals }}
              </span>
            </div>
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="orange darken-1">mdi-calendar-range</v-icon>
                Últimos 90 días
              </span>
              <span class="text-subtitle-2 font-weight-bold orange--text text--darken-2">
                $ {{ (parseFloat(edited.deuda_usuario_90) || 0) | formatToTwoDecimals }}
              </span>
            </div>
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="red darken-1">mdi-calendar-alert</v-icon>
                Más de 90 días
              </span>
              <span class="text-subtitle-2 font-weight-bold red--text text--darken-2">
                $ {{ (parseFloat(edited.deuda_usuario_mas_90) || 0) | formatToTwoDecimals }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card
          class="mx-auto"
          max-width="400"
          :loading="loading"
        >
          <v-card-title class="text-h6 font-weight-bold">
            $ {{ (parseFloat(edited.subsidio_sin_utilizar) || 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon color="success">mdi-ticket-percent</v-icon>
          </v-card-title>

          <v-card-subtitle class="pb-1 font-weight-medium">Subsidio sin utilizar.</v-card-subtitle>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-card-text class="pt-0 px-4 pb-3">
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="green darken-1">mdi-calendar-range</v-icon>
                Últimos 30 días
              </span>
              <span class="text-subtitle-2 font-weight-bold green--text text--darken-2">
                $ {{ (parseFloat(edited.subsidio_sin_utilizar_30) || 0) | formatToTwoDecimals }}
              </span>
            </div>
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="orange darken-1">mdi-calendar-range</v-icon>
                Últimos 90 días
              </span>
              <span class="text-subtitle-2 font-weight-bold orange--text text--darken-2">
                $ {{ (parseFloat(edited.subsidio_sin_utilizar_90) || 0) | formatToTwoDecimals }}
              </span>
            </div>
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="red darken-1">mdi-calendar-alert</v-icon>
                Más de 90 días
              </span>
              <span class="text-subtitle-2 font-weight-bold red--text text--darken-2">
                $ {{ (parseFloat(edited.subsidio_sin_utilizar_mas_90) || 0) | formatToTwoDecimals }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card
          class="mx-auto"
          max-width="400"
          :loading="loading"
        >
          <v-card-title class="text-h6 font-weight-bold">
            $ {{ (parseFloat(edited.deuda_sin_subsidio) || 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon color="warning">mdi-alert-circle-outline</v-icon>
          </v-card-title>

          <v-card-subtitle class="pb-1 font-weight-medium">Deuda actual</v-card-subtitle>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-card-text class="pt-0 px-4 pb-3">
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="green darken-1">mdi-calendar-range</v-icon>
                Últimos 30 días
              </span>
              <span class="text-subtitle-2 font-weight-bold green--text text--darken-2">
                $ {{ (parseFloat(edited.deuda_sin_subsidio_30) || 0) | formatToTwoDecimals }}
              </span>
            </div>
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="orange darken-1">mdi-calendar-range</v-icon>
                Últimos 90 días
              </span>
              <span class="text-subtitle-2 font-weight-bold orange--text text--darken-2">
                $ {{ (parseFloat(edited.deuda_sin_subsidio_90) || 0) | formatToTwoDecimals }}
              </span>
            </div>
            <div class="d-flex justify-space-between py-1 align-center">
              <span class="text-caption grey--text text--darken-1 font-weight-medium">
                <v-icon small class="mr-1" color="red darken-1">mdi-calendar-alert</v-icon>
                Más de 90 días
              </span>
              <span class="text-subtitle-2 font-weight-bold red--text text--darken-2">
                $ {{ (parseFloat(edited.deuda_sin_subsidio_mas_90) || 0) | formatToTwoDecimals }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductosMixin from '@/mixins/Productos'
import FormasDePagosMixin from '@/mixins/FormasDePagos'
export default {
  name: 'ReportesActualesComponent',
  mixins: [ProductosMixin, FormasDePagosMixin],
  data () {
    return {
      //
    }
  },
  beforeDestroy () {
    this.onClearEdited()
  },
  created () {
    this.onFetch()
  },
  computed: {
    ...mapGetters('ReportesActuales', ['edited', 'loading', 'filters']),
  },
  methods: {
    ...mapActions('ReportesActuales', ['onClearEdited', 'onFetch'])
  }
}
</script>
